import { defaultHttpClient } from './_HttpClient';
export async function LoadInventory(productId) {
    const params = new FormData();
    params.append('ProductId', productId.toString());
    const response = await defaultHttpClient.post('/Ajax/OrderCustomize.ashx?action=getstocklist', params);
    const data = response.data.Data;
    return data;
}
